import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@lite-workspace/shared/blocks/icon';
import { HlmBadge } from '@lite-workspace/shared/helm-ui/badge';

@Component({
  selector: 'app-comment-badge',
  imports: [HlmBadge, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.role]': 'count() > 0 ? "img" : null',
    '[attr.aria-label]': 'count() > 0 ? "Комментарии: " + count() : null',
  },
  template: `
    @if (count() > 0) {
      @if (kind() === 'count') {
        <!-- Corner of a button that already shows message-square: a second bubble would cover it. -->
        <span
          class="inline-flex h-4 min-w-4 items-center justify-center rounded-full px-1
            text-2xs font-semibold leading-none tabular-nums"
          [class]="tone() === 'accent' ? 'bg-acc text-on-acc' : 'bg-acc-soft-solid text-acc2'"
          >{{ count() > 99 ? '99+' : count() }}</span
        >
      } @else {
        <span hlmBadge [variant]="tone() === 'accent' ? 'acc-solid' : 'acc-outline'" class="rounded-full tabular-nums">
          <app-icon name="message-square" [size]="12" />{{ count() }}
        </span>
      }
    }
  `,
})
export class CommentBadgeComponent {
  readonly count = input.required<number>();
  readonly tone = input<'muted' | 'accent'>('muted');
  readonly kind = input<'pill' | 'count'>('pill');
}
